import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { map, take } from 'rxjs';

import { DEV_MODE_QUERY_PARAMS } from '@app/core/init/utils';

import { AuthSessionService } from '@core/services/auth-session.service';

/**
 * Na rota de login interno: redireciona para a app se a sessão já estiver ativa.
 */
export const internalLoginSessionGuard: CanActivateFn = () => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);

  return auth.isAuthenticated$.pipe(
    take(1),
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        return true;
      }

      return router.createUrlTree(['/inicio'], {
        queryParams: { ...DEV_MODE_QUERY_PARAMS }
      });
    })
  );
};
